import Ansile from '@/assets/member-photos/Ansile.png';
import StealthTech from '@/assets/member-photos/StealthTech.png';
import LionZXY from '@/assets/member-photos/LionZXY.png';
import reo7sp from '@/assets/member-photos/reo7sp.png';

import tags from '@/store/tags';

export default {
  Ansile: {
    name: 'Голубев Юрий',
    occupation: 'Frontend-разработчик в проекте Почта Mail.ru',
    photo: Ansile,
    contacts: {
      vk: 'vk.com/ansile',
      email: 'y.golubev@corp.mail.ru',
    },
    description:
      'Люблю печенье и молоко.\n'
      + 'Программирую как на работе, так и just for fun.\n'
      + 'Беру отпуск, чтобы попрограммировать на другом языке :)\n'
      + 'По жизни в проприетарщине, душой в опенсорсе.\n'
      + '\n'
      + 'Геймер, любитель сериалов, insert adjective here.',
    favourite: [
      tags.ts,
      tags.js,
      tags.rust,
      tags.reactWork,
      tags.vueLife,
      tags.svelte,
      tags.python,
      tags.nginx,
      tags.webpack,
      tags.puppet,
    ],
  },
  StealthTech: {
    name: 'Волынов Михаил',
    occupation: 'Frontend-разработчик в проекте VK WorkSpace',
    photo: StealthTech,
    description: 'Люблю общественно полезные задачи и проекты. Работаю в IT, потому что это позволяет делать жизнь других людей лучше.\n\n'
      + 'Разрабатываю фронтенд проекта VK WorkSpace, а также являюсь менеджером менторской программы VK Образование.\n\n'
      + 'Ранее занимался фронтенд-разработкой в Почте Mail.ru. Перед этим — управлением проектами и автоматизацией маркетинга в соревнованиях от Mail.ru Group для программистов, а ещё раньше — разработкой там же и в образовательных проектах Mail.ru Group. Умею переводить с менеджерского на программерский и наоборот. :)\n\n'
      + 'Веду личный блог в Telegram про веб-разработку и жизнь — он указан в ссылках ниже 😉',
    favourite: [
      tags.js,
      tags.ts,
      tags.python,
      tags.bash,
      tags.react,
      tags.svelte,
      tags.django,
      tags.scss,
      tags.nginx,
      tags.photoshop,
      tags.figma,
    ],
    contacts: {
      vk: 'vk.com/stealth_tech',
      email: 'mikhail@volynov.ru',
      website: 'https://t.me/repulsor',
    },
  },
  LionZXY: {
    name: 'Куликов Никита',
    occupation: 'Head of Mobile in Flipper Devices',
    photo: LionZXY,
    description: 'Делал стартапы, работал в Яндексе, аутсорсе и мейле. Сейчас делаю приложения для хакерского мультитула-тамагочи. Тренирую навык публичных выступлений преподаванием и публичными выступлениями. Из бесполезных знаний: ассемблер ARM, программирование на STM32, минимум пять способов добраться до любой аудитории Бауманки. \n'
      + '\n'
      + 'Пытаюсь не скатиться в депрессию и развиваюсь.',
    favourite: [
      tags.kotlin,
      tags.java,
      tags.cpp,
      tags.flutter,
      tags.reactNative,
      tags.android,
    ],
    contacts: {
      vk: 'vk.com/lionzxy',
    },
  },
  reo7sp: {
    name: 'Морозенков Олег',
    occupation: 'Backend-разработчик в проекте Почта Mail.ru Group',
    photo: reo7sp,
    description: 'Этот парень был из тех\n'
      + 'Кто просто любит жизнь\n'
      + 'Любит праздники и громкий смех,\n'
      + 'Пыль дорог и ветра свист.\n'
      + 'Он был везде и всегда своим\n'
      + 'Влюблял в себя целый свет\n'
      + 'И гнал свой байк, а не лимузин\n'
      + 'Таких друзей больше нет...',
    favourite: [
      tags.c,
      tags.python,
    ],
    contacts: {
      vk: 'vk.com/reo7sp',
      email: 'm@oleg.rocks',
      website: 'oleg.rocks',
    },
  },
};
